import { isDisabled } from "@testing-library/user-event/dist/utils";
import { RenameObjectInput } from "../../../../../common/RenameObjectInput";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { FILE_PREVIEWER_ACTIONS } from "../../../constants";
import { TFilePreviewerActions } from "../../../types";
import styles from "./styles.module.css";
import { DownloadFileButton } from "../../../../../common/Components/Buttons/DownloadFileButton";

interface Props {
  filePreviewerActions: (type: TFilePreviewerActions) => void;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  className?: string;
}

export const FilesHeader = ({
  filePreviewerActions,
  isReadOnly,
  isDisabled,
}: Props) => {
  return (
    <div className={styles["files-service-header"]}>
      <RenameObjectInput
        service={"userfiles"}
        inputType={"text_field"}
        isDisabled={isDisabled || isReadOnly}
        className={styles["name-change-input"]}
      />
      <div className={styles["actions-container"]}>
        <DownloadFileButton
          onDownload={() =>
            filePreviewerActions("download" as TFilePreviewerActions)
          }
        />
      </div>
    </div>
  );
};
